<template>
  <kst-page-print pageFooter
    v-slot="{ title }"
    :catalog="PlosSearchCatalog"
    :params="Model.Search.ListParams"
    :search="searchData"
    @init="handleInit"
  >
    <div class="columns is-mobile">
      <div class="column is-half">
        <Company :data="companyData"/>
      </div>
      <div class="column is-half">
        <div class="is-size-3">{{ title }}</div>
        <div class="is-flex">{{ Model.Print.getTotalInfo(summaryData) }}</div>
      </div>
    </div>

    <List class="block" :summaryData="summaryData"/>
  </kst-page-print>
</template>

<script>
import Model from "../PlosModel.js";
import PlosSearchCatalog from "../PlosSearchCatalog.js";
import Services from "../../../services/Api/ProfitLossServices.js";

import List from "./PlosP_List.vue";
import Company from "../../Company/RelatedPrintDetails/CpRPD.vue";

export default {
  components: {
    List,
    Company
  },
  data: () => ({
    Model: Model,
    PlosSearchCatalog: PlosSearchCatalog,
    companyData: {},
    summaryData: {},
    searchData: {
      Date: null,
      WarehouseID: null,
      // by system
      RptTypeID: null
    }
  }),
  created() {
    this.resetSearch();
  },
  methods: {
    /*** by page ***/

    handleInit(loadPrint) {
      this.resetData();

      const options = this.getOptions();
      const config = Services.getPrintData(options);
      loadPrint(config, this.handleInit_success);
    },
    handleInit_success(data) {
      this.companyData = data.CompanyDetails;
      this.searchData.RptTypeID = data.CompanySettingDetails.ProfitLossRptTypeID;
      this.summaryData = Model.Print.getSummary(data.TransactionDetails,
        this.searchData
      );
    },

    /*** custom ***/

    resetData() {
      this.companyData = {};
      this.summaryData = Model.createSummary();
    },

    resetSearch() {
      this.searchData.Date = this.$kst.In.getDefaultDateRange();
      this.searchData.WarehouseID = this.$kst.Session.getDefaultWarehouseID();
      // by system
      this.searchData.RptTypeID = null;
    },

    getOptions() {
      return {
        startdate: this.$kst.Out.getDateString(this.searchData.Date[0]),
        enddate: this.$kst.Out.getDateString(this.searchData.Date[1]),
        warehouse: this.$kst.Search.getValue(this.searchData.WarehouseID)
      };
    }
  }
}
</script>